<template>
    <div>
        <Modal v-model="dialogShow" width="640" class-name="vertical-center-modal no-padding">
            <div class="close-btn" slot="close">
                <i class="iconfont icon-pop-close" style="color:#353538"></i>
            </div>
            <div class="dg-header" slot="header">
                <p>面料色卡与家具色板</p>
                <img src="../../../../images/vip/color_card_head_bg.png" alt="">
            </div>
            <div class="cont">
                <div class="icon">
                    <img src="../../../../images/vip/color_card_cont_bg.png" alt="">
                </div>
                <div class="form">
                    <p>输入信息领取色板</p>
                    <div class="form-row first">
                        <span class="form-lbl"><span class="red-font">* </span>收货人：</span>
                        <input type="text" v-model="location.receiver">
                        <span class="form-lbl" style="margin-left:44px;"><span class="red-font">* </span>手机号：</span>
                        <input v-model="location.phone" type="number">
                    </div>
                    <div class="form-row second">
                        <span class="form-lbl"><span class="red-font">* </span>详细地址：</span>
                        <input type="text" v-model="location.detailAddress">
                    </div>
                    <div class="form-row">
                        <span class="form-lbl" style="vertical-align: top">兑换须知：</span>
                        <div class="form-text">
                            <p>1.请确保您填写的收货地址准确无误</p>
                            <p>2.兑换将消耗您70000个恐龙蛋，不支持退换</p>
                        </div>
                    </div>
                </div>
                <div class="footer">
                    <button class="cancel-btn" @click="dialogShow = false">取消</button>
                    <button class="red-btn" @click="submit">确认</button>
                </div>
            </div>
        </Modal>
        <deduction-egg ref="deduction" @offerSubmit="offerSubmit"></deduction-egg>
    </div>
</template>
<script>
    import api from '../../../../api'
    import validator from '../../account/validator'
    import deductionEgg from '../../../common/deductionEgg.vue'
    export default{
        data(){
            return {
                dialogShow:false,
                location:{},
                isMsg: false
            }
        },
        components:{
            deductionEgg
        },
        methods:{
            open(){
                this.dialogShow = true;
                this.location = {
                    receiver:'',
                    phone:undefined,
                    detailAddress:''
                };
            },
            submit(){
                if(!this.location.receiver.trim()){
                    this.$Message.warning('收货人必填');
                    return;
                }
                if(!validator.reg_phone.test(this.location.phone)){
                    this.$Message.warning('手机号必填且为11位');
                    return;
                }
                if(!this.location.detailAddress.trim()){
                    this.$Message.warning('详细地址必填');
                    return;
                }
                this.$refs.deduction.open('exchange', 70000);
            },
            submitSure(){
                api.points.exchangeColor(this.location)
                    .then(()=>{
                        this.dialogShow = false;
                        this.$refs.deduction.cancel();
                        this.$emit('exchangeSuc', 'color');
                    });
            },
            offerSubmit(){
                this.submitSure()
            },

        }
    }
</script>
<style scoped>
    .dg-header img{
        position:absolute;
        left:0;
        top:0;
    }
    .dg-header p{
        line-height:30px;
        height:30px;
        position:relative;
        z-index:2;
        color:#fff;
        font-size: 20px;
        font-weight:normal;
        text-align: center;
    }
    .icon{
        margin-top:12px;
    }
    .icon img{
        width:320px;
    }
    .cont{
        padding:0 40px;
    }
    .form{
        margin-top:-46px;
    }
    .form>p{
        font-size: 14px;
        letter-spacing: 2.33px;
        text-align: left;
    }
    .form .form-row{
        margin-top:10px;
        text-align: left;
    }
    .form .form-row .form-lbl {
        width: 68px;
        display: inline-block;
        vertical-align: middle;
        text-align: left;
        font-size:12px;
    }
    .form .form-row input{
        border: 1px solid #DCE0E0;
        border-radius: 4px;
        height:34px;
        line-height:34px;
        padding:0 5px;
        font-size:12px;
    }
    .form .form-row.first input{
        width:118px;
    }
    .form .form-row.second input{
        width:474px;
    }
    .form .form-row .form-text{
        display:inline-block;
        width:474px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        font-size: 12px;
        color: #6C6F70;
    }
    .footer{
        text-align: center;
        padding:30px 0 40px;
    }
    .footer button{
        border-radius: 4px;
        width:145px;
        height:44px;
        line-height:44px;
    }
    .footer button:first-child{
        margin-right:20px;
    }
</style>
